import { GET_VEHICALTYREPOSITION_REQUEST, GET_VEHICALTYREPOSITION_SUCCESS, GET_VEHICALTYREPOSITION_FAIL,
    UPDATE_VEHICALTYREPOSITION_REQUEST, UPDATE_VEHICALTYREPOSITION_SUCCESS, UPDATE_VEHICALTYREPOSITION_FAIL,
    CREATE_VEHICLETYPE_REQUEST, CREATE_VEHICLETYPE_SUCCESS, CREATE_VEHICLETYPE_FAIL,
    UPDATE_VEHICLETYPE_REQUEST, UPDATE_VEHICLETYPE_SUCCESS, UPDATE_VEHICLETYPE_FAIL,
    GET_VEHICLETYPE_REQUEST, GET_VEHICLETYPE_SUCCESS, GET_VEHICLETYPE_FAIL,GET_MAPPED_VEHICALTYREPOSITION_REQUEST
    ,GET_MAPPED_VEHICALTYREPOSITION_FAIL,GET_MAPPED_VEHICALTYREPOSITION_SUCCESS} from '../types/vehicleTypes'
import Axios from 'axios'
import APP_CONSTANT from '../../config/constants'
import cogoToast from 'cogo-toast';
import { reject } from 'lodash';


export const getVehicleType = (id) => async (dispatch) => {
    dispatch({ type: GET_VEHICLETYPE_REQUEST });
    try {
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNumber": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            "vehicleTypeMasterId" : id,
            "searchString": ""
        }
        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}masters/vehicleTypeMaster`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: GET_VEHICLETYPE_SUCCESS, payload: data });
        
        console.log("====Vehicle Type Created", data)
    } catch (error) {
        dispatch({ type: GET_VEHICLETYPE_FAIL, payload: error.message })
    }
}

export const updateVehicleType = (uploadData) => async (dispatch) => {
    dispatch({ type: UPDATE_VEHICLETYPE_REQUEST });
    try {
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNo": localStorage.getItem('customerNo'),
            "customerNumber": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            "vehTypeId": uploadData.vehicleTypeId,
            "vehicleTypeCode" : uploadData.vehicleTypeCode,
            "vehicleType": uploadData.vehicleTypeName,
            "vehicleTypeTyre": uploadData.vehicleTypeTyre
        }
        const { data } = await Axios.patch(`${APP_CONSTANT.BASE_URL}masters/vehicleTypeMaster/${uploadData.vehicleTypeId}`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: UPDATE_VEHICLETYPE_SUCCESS, payload: data });
        if(data.status == 204){
            cogoToast.error(data.message)
            // alert("Vehicle Type updated successfully"
            
            
        }else if(data.status == 200){
            cogoToast.success(data.message)
            setInterval(() => {
              window.location.href = '/vehicle-type'  
            }, 3000);
            // alert(data.message)
        }
        
        console.log("====Vehicle Type Created", data)
        return data
    } catch (error) {
        dispatch({ type: UPDATE_VEHICLETYPE_FAIL, payload: error.message })
    }
}


export const getTyrePosition = () => async (dispatch) => {
    dispatch({ type: GET_VEHICALTYREPOSITION_REQUEST });
    try {
            let apiToken =  localStorage.getItem('apiToken')
            let customerNo = localStorage.getItem('customerNo')
            let userId = localStorage.getItem('userId')
        
        const { data } = await Axios.get(`${APP_CONSTANT.BASE_URL}masters/tyrePosition/?customerNumber=${customerNo}&userId=${userId}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: GET_VEHICALTYREPOSITION_SUCCESS, payload: data });       
      return data
    } catch (error) {
        dispatch({ type: GET_VEHICALTYREPOSITION_FAIL, payload: error.message })
    }
}


export const updateTyrePosition = (object) => async (dispatch) => {
    console.log(object,'tyre position')
    // https://dev-commongateway.elixia.tech/masters/vehicleTypeTyrePositionMapping/?customerNumber=1371&userId=257&vehicleTypeId=523
    dispatch({ type: UPDATE_VEHICALTYREPOSITION_REQUEST });
    try {
        
            let apiToken =  localStorage.getItem('apiToken')
            let customerNo = localStorage.getItem('customerNo')
            let userId = localStorage.getItem('userId')
        
        const { data } = await Axios.put(`${APP_CONSTANT.BASE_URL}masters/vehicleTypeTyrePositionMapping/?customerNumber=${customerNo}&userId=${userId}`,object, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: UPDATE_VEHICALTYREPOSITION_SUCCESS, payload: data });
        console.log("====TyrePos List", data)
        if(data.status == 200){
            // cogoToast.success(data.message)
            setTimeout(() => {
                window.location.href = "/vehicle-type" 
            }, 1000);
        }else{
            cogoToast.error(data.message)
        }

    } catch (error) {
        dispatch({ type: UPDATE_VEHICALTYREPOSITION_FAIL, payload: error.message })
    }
}


export const getMappedTyre = (object) => async (dispatch) => {
    console.log(object,'dataaa')
    // https://dev-commongateway.elixia.tech/masters/vehicleTypeTyrePositionMapping/?customerNumber=1371&userId=257&vehicleTypeId=523
    dispatch({ type: GET_MAPPED_VEHICALTYREPOSITION_REQUEST });
    try {
        
            let apiToken =  localStorage.getItem('apiToken')
            let customerNo = localStorage.getItem('customerNo')
            let userId = localStorage.getItem('userId')
        
        const { data } = await Axios.get(`${APP_CONSTANT.BASE_URL}masters/vehicleTypeTyrePositionMapping/?customerNumber=${customerNo}&userId=${userId}&vehicleTypeId=${object}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": apiToken,
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: GET_MAPPED_VEHICALTYREPOSITION_SUCCESS, payload: data });
        console.log("====TyrePos List", data)
        return data

    } catch (error) {
        dispatch({ type: GET_MAPPED_VEHICALTYREPOSITION_FAIL, payload: error.message })
    }
}

export const createVehicleType = (uploadData) => async (dispatch) => {
    dispatch({ type: CREATE_VEHICLETYPE_REQUEST });
    try {
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNo": localStorage.getItem('customerNo'),
            "customerNumber": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            "vehicleTypeCode" : uploadData.vehicleTypeCode,
            "vehicleType": uploadData.vehicleTypeName,
            "vehicleTypeTyre": uploadData.vehicleTypeTyre
        }
        const { data } = await Axios.put(`${APP_CONSTANT.BASE_URL}masters/vehicleTypeMaster`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        
        dispatch({ type: CREATE_VEHICLETYPE_SUCCESS, payload: data });
        
        console.log(data,"response createVehicleType")
        if(data.status == 204){
            cogoToast.error(data.message)
            return data
           
            // setInterval(() => {
            //     window.location.href = '/vehicle-type' 
            // }, 1000);
           
        }else{
            return data
            // alert(data.message)
        }
        
        
    } catch (error) {
        dispatch({ type: CREATE_VEHICLETYPE_FAIL, payload: error.message })
    }
}


